import Emoji from "@core-components/emoji/Emoji";
import InfoArea from "@core-components/info-area/InfoArea";
import SSHeadline from "@core-components/title/SSHeadline";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Text } from "@mantine/core";
import { Trans } from "react-i18next";

interface SkinInfoAreaProps {
  skinName: string | undefined;
}

export const SkinInfoArea = ({ skinName }: SkinInfoAreaProps) => {
  const { t } = useAppTranslation("pages.skins.skin");

  return (
    <InfoArea
      hasShadow
      className="xs:!p-5 md:!p-10 !max-w-[800px]"
      description={
        <>
          <Text>
            <Trans
              i18nKey="pages.skins.skin.infoArea.accountInfo"
              values={{ name: skinName }}
            >
              Compte League of Legends avec le skin{" "}
              <Text span fw="bold">
                {skinName}
              </Text>
              , commencez votre parcours en classé avec votre skin favori
              aujourd&apos;hui !
            </Trans>
          </Text>
          <br />
          <Text>
            <Text span fw="bold">
              {t("infoArea.warningTitle")}{" "}
            </Text>
            {t("infoArea.warningText")}
          </Text>
        </>
      }
      fullWidth={false}
      headLine={
        <SSHeadline
          props={{
            title: {
              size: 24,
            },
          }}
        >
          <Emoji.Pin />
          <SSWhiteText> {t("infoArea.headline")}</SSWhiteText>
        </SSHeadline>
      }
    />
  );
};
